// extracted by mini-css-extract-plugin
export default {"minHeight":"ActivityOverTime_minHeight__KZFfh"};